// extracted by mini-css-extract-plugin
module.exports = {"standardVideo":"gif-video-module--standardVideo--2DKJS","caption":"gif-video-module--caption--1_Gzc","primaryContent":"gif-video-module--primaryContent--2Vy17"};